import React, { useState } from 'react';
import { ArrowLeft, Download, Globe } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';

const Catalog = () => {
  const [language, setLanguage] = useState('tr');
  
  const catalogs = {
    tr: {
      url: 'https://customer-assets.emergentagent.com/job_elerien-tr/artifacts/pg5k04ga_ELEREIN%20MAKI%CC%87NELER%202025.pdf',
      title: 'Elerein Ürün Kataloğu 2025 - Türkçe',
      filename: 'ELEREIN_MAKİNELER_2025.pdf',
      downloadText: 'PDF İndir (Türkçe)',
      errorText: 'PDF görüntüleyicide sorun mu yaşıyorsunuz?',
      alternativeText: 'Kataloğu buradan indirebilirsiniz'
    },
    en: {
      url: 'https://customer-assets.emergentagent.com/job_elerien-tr/artifacts/4pytz0sd_ELEREIN%20products%202025.pdf',
      title: 'Elerein Product Catalog 2025 - English',
      filename: 'ELEREIN_PRODUCTS_2025.pdf',
      downloadText: 'Download PDF (English)',
      errorText: 'Having trouble with the PDF viewer?',
      alternativeText: 'Download the catalog here'
    }
  };

  const currentCatalog = catalogs[language];

  return (
    <div className="min-h-screen pt-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Header */}
        <div className="flex items-center justify-between mb-6 flex-wrap gap-4">
          <div className="flex items-center space-x-4">
            <Link to="/professional">
              <Button variant="outline" className="flex items-center">
                <ArrowLeft className="w-4 h-4 mr-2" />
                Geri Dön
              </Button>
            </Link>
            <h1 className="text-3xl font-bold text-gray-900">{currentCatalog.title}</h1>
          </div>
          
          <div className="flex items-center space-x-3">
            {/* Language Selector */}
            <div className="flex bg-white rounded-lg shadow-md overflow-hidden border border-gray-200">
              <button
                onClick={() => setLanguage('tr')}
                className={`px-4 py-2 font-semibold transition-colors flex items-center ${
                  language === 'tr' 
                    ? 'bg-sky-500 text-white' 
                    : 'bg-white text-gray-700 hover:bg-gray-50'
                }`}
              >
                <Globe className="w-4 h-4 mr-2" />
                Türkçe
              </button>
              <button
                onClick={() => setLanguage('en')}
                className={`px-4 py-2 font-semibold transition-colors flex items-center ${
                  language === 'en' 
                    ? 'bg-sky-500 text-white' 
                    : 'bg-white text-gray-700 hover:bg-gray-50'
                }`}
              >
                <Globe className="w-4 h-4 mr-2" />
                English
              </button>
            </div>
            
            {/* Download Button */}
            <a href={currentCatalog.url} download={currentCatalog.filename}>
              <Button className="bg-sky-500 hover:bg-sky-600 text-white">
                <Download className="w-4 h-4 mr-2" />
                {currentCatalog.downloadText}
              </Button>
            </a>
          </div>
        </div>

        {/* PDF Viewer */}
        <div className="bg-white rounded-lg shadow-xl overflow-hidden">
          <div className="relative" style={{ height: 'calc(100vh - 220px)' }}>
            <iframe
              key={language}
              src={currentCatalog.url}
              className="w-full h-full border-0"
              title={currentCatalog.title}
            />
          </div>
        </div>

        {/* Alternative Download Link */}
        <div className="mt-6 text-center">
          <p className="text-gray-600 mb-3">
            {currentCatalog.errorText}
          </p>
          <a 
            href={currentCatalog.url} 
            download={currentCatalog.filename}
            className="text-sky-500 hover:text-sky-600 font-semibold underline"
          >
            {currentCatalog.alternativeText}
          </a>
        </div>
      </div>
    </div>
  );
};

export default Catalog;
